(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.resizeOb = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var resizeOb = exports.resizeOb = {
    props: {
      _autoResize: {
        type: Boolean,
        default: true
      }
    },
    data: function data() {
      return {
        _resizeObElement: null,
        _resizeOb: null,
        _resizeObElementWidth: 0,
        _resizeObElementHeight: 0,
        resizeObNum: 0
      };
    },

    methods: {
      $obReInit: function $obReInit(ob) {
        var _this = this;

        this._resizeObElement = ob.el || this.$el;
        this.$nextTick(function () {
          _this._resizeObElementWidth = _this._resizeObElement.clientHeight || 0;
          _this._resizeObElementHeight = _this._resizeObElement.clientHeight || 0;
          _this.$processWrapperWidthChange(ob.cbWidth, ob.cbHeight, ob.unLimitResizeObNum);
        });
      },
      $processWrapperWidthChange: function $processWrapperWidthChange() {
        var cbWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

        var _this2 = this;

        var cbHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
        var unLimitResizeObNum = arguments[2];

        var ResizeNumberLimit = 5;
        if (!window.ResizeObserver || !this._autoResize) return;
        this._resizeOb = new window.ResizeObserver(function (entries) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var entry = _step.value;

              if (!entry || !entry.contentRect) continue;
              var realWidth = entry.contentRect.width || 0;
              var realHeight = entry.contentRect.height || 0;
              if (realWidth && realWidth !== _this2._resizeObElementWidth) {
                cbWidth && cbWidth();
              }
              if (realHeight && realHeight !== _this2._resizeObElementHeight) {
                cbHeight && cbHeight();
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          if (!unLimitResizeObNum) {
            // 触发次数达到上限，不再触发
            _this2.resizeObNum++;
            if (_this2.resizeObNum >= ResizeNumberLimit && _this2._resizeOb) {
              _this2.$unProcessWrapperWidthChange();
            }
          }
        });
        this._resizeOb.observe(this._resizeObElement);
      },
      $unProcessWrapperWidthChange: function $unProcessWrapperWidthChange() {
        if (!window.ResizeObserver || !this._autoResize || !this._resizeOb) return;
        this._resizeObElement && this._resizeOb.unobserve(this._resizeObElement);
        this._resizeOb = null;
      }
    },
    destroyed: function destroyed() {
      this.$unProcessWrapperWidthChange();
    }
  };
});